

export enum DiaFuncionamento {

    SEGUNDA_SABADO = "Segunda a sábado",
    SEGUNDA_SEXTA = "Segunda a sexta",
    TERCA_DOMINGO = "Terça a domingo",
    NAO_DEFINIR = "Não definir agora"

}